import { ESTADO_VENTA } from "../../_helpers";
import {ventasService} from "../ventas.service";
import alertService from "./alert.service";
import http from "./http.service";

class VentaService {

    ventasComprador: any[] = [];

    constructor() {

    }

    formatEstado= (estado:string) => {

        switch(estado){
            case ESTADO_VENTA.CANCELADA:
                return 'Cancelada';
            case ESTADO_VENTA.PENDIENTE_ENTREGA:
                return 'Pendiente de Entrega';
            case ESTADO_VENTA.PENDIENTE_PAGO:
                return 'Pendiente de Pago';
            case ESTADO_VENTA.FINALIZADA:
                return 'Finalizada';
            case ESTADO_VENTA.PAGADA:
                return 'Pagada';
        }

    }

    getVentaComprador = (id: number, onSuccess: Function) => {

        if (this.ventasComprador.length === 0 || !this.ventasComprador.some(it => it.id === id)) {

            ventasService.getVentaById({id: id})
                .then((data: any) => {
                    onSuccess(data);
                })
                .catch((error: any) => {
                    alertService.error(error)

                })

        }

    }

    buscarTotalPublicaciones = (onSuccess: any) => {

        http.get('/api/ventas/buscarTotalVentas')
            .then(
                (data: any) => {
                    onSuccess(data);
                },
                (error: any) => alertService.error(error)
            );

    }

}


const ventaService = new VentaService();

export default ventaService;
